module.exports = __webpack_public_path__ + "img/man_menu_hover.32d15bc2.svg";